export class CategoriaContasReceber {
    id: string
    nome: string
    valor: number
    descricao: string
    idAssociacao: string
}